import toast from 'react-hot-toast';
import useApi from '../useApi';

const useDeleteUser = ({ clinicId }: { clinicId?: string }) => {
  const { loading: deleteUserLoading, makeApiCall } = useApi({
    url: `/users/${clinicId}`,
    method: 'DELETE',
  });

  const deleteUser = async () => {
    const { error } = await makeApiCall<undefined, undefined>();

    if (error) {
      toast.error('Something went wrong whiling deleting clinic. Please try again later');
      return { status: false };
    } else {
      toast.error('User deleted successfully.');
    }
  };

  return {
    deleteUserLoading,
    deleteUser,
  };
};

export default useDeleteUser;
